import * as R from 'ramda'
import schemaAt from 'coact/utils/schema/schemaAt'

import schemaModule from '../../../../utils/schema/index.js'

import { reqData } from '../../../purchaseReq/index.js'

// for populate schema
const orderSchema = R.pipe(
  R.dissocPath(['contents', 'items']),
  schemaModule.create,
)(reqData.schema)

const schema = R.pipe(
  R.assocPath(['contents', 'orderRef'], orderSchema),
  R.assocPath(['contents', 'unarrivedQty'], { type: 'Number', label: '未到' }),
  R.assocPath(['contents', 'onTheWayQty'], { type: 'Number', label: '在途' }),
  schemaModule.create,
)(schemaAt(['items', 0], reqData.schema)) // itemSchema

export default schema
